/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_Mark_SoldInputs */

const cs_property_mark_sold = /** @type {(inputs: Property_Mark_SoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Označit jako prodané`)
};

const en_property_mark_sold = /** @type {(inputs: Property_Mark_SoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark as sold`)
};

/**
* | output |
* | --- |
* | "Mark as sold" |
*
* @param {Property_Mark_SoldInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_mark_sold = /** @type {((inputs?: Property_Mark_SoldInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Mark_SoldInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_mark_sold(inputs)
	return cs_property_mark_sold(inputs)
});